import React, { useMemo } from "react";
import { useProfile, CURRENT_TAX_YEAR } from "@moonscape/shared";
import { KeyDatesTimeline } from "@/components/Tax/KeyDatesTimeline";
import { FilingBanner, type FilingStep } from "@/components/Tax/FilingBanner";

export const FilingCountdownWidget: React.FC = () => {
  const { profile } = useProfile();

  const jurisdiction = profile?.taxJurisdiction;
  const taxYear = CURRENT_TAX_YEAR - 1; // filing for previous year

  const steps: FilingStep[] = useMemo(() => {
    if (!profile) return [];
    return [
      {
        label: "Connect sources",
        completed: !!profile.hasLinkExchangeAccounts,
      },
      {
        label: "Tax settings",
        completed: !!profile.hasRequiredTaxInfo,
      },
      {
        label: "Resolve issues",
        completed: false, // requires audit data from parent — always shown as pending
      },
      {
        label: "Generate forms",
        completed: false,
      },
    ];
  }, [profile]);

  if (!jurisdiction) return null;

  return (
    <div className="flex flex-col gap-4">
      <FilingBanner
        taxYear={taxYear}
        jurisdiction={jurisdiction}
        steps={steps}
        reportsLink={`/tax/${taxYear}/reports`}
      />
      <KeyDatesTimeline taxYear={taxYear} jurisdiction={jurisdiction} />
    </div>
  );
};
